import { Component, inject, OnInit, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  templateUrl: './loading-dialog.component.html',
  styleUrl: './loading-dialog.component.scss',
  imports: [MatProgressBarModule],
})
export class LoadingDialogComponent implements OnInit {
  private data = inject(MAT_DIALOG_DATA) as { customerCount: number };

  public dialog = inject(MatDialogRef<LoadingDialogComponent>);

  readonly statements: string[] = [
    "We've received your request (1/10)",
    'Setting up your account (2/10)',
    'Getting things ready for you (3/10)',
    'Creating your user profile (4/10)',
    'Preparing your workspace (5/10)',
    'Connecting to clients (6/10)',
    'Setting up your access (7/10)',
    'Loading your permissions (8/10)',
    'Almost there... (9/10)',
    'Finalising your setup (10/10)',
  ];

  readonly activeStatement = signal(this.statements[0]);

  ngOnInit() {
    this.dialog.disableClose = true;

    const totalTime = Math.round(this.data.customerCount * 0.8);
    const intervalPerStatement = (totalTime / this.statements.length) * 1000;
    let index = 0;

    const interval = setInterval(() => {
      index++;
      if (index >= this.statements.length) {
        clearInterval(interval);
      } else {
        this.activeStatement.set(this.statements[index]);
      }
    }, intervalPerStatement);
  }
}
